import {combineReducers} from "redux";
import userReducer from "./user";
import payReducer from "../../containers/Pay/store/reducer";
import error from "./error";
import lang from "./lang";
import globalReducer from "./global";

export default combineReducers({
  userReducer,
  payment: payReducer,
  erreducer: error,
  language: lang,
  globalReducer
});
